export const setSelectTournament = (tournamet)=>{
    sessionStorage.setItem('selectedTournament', JSON.stringify(tournamet))
}

export const getSelectedTournament = ()=>{
    return JSON.parse(sessionStorage.getItem('selectedTournament')) || ''
}